import React, { useState } from 'react'
import { Typography, Image, Table } from 'antd';
import directxImg from "../../img/directx.png"
import loginImg from "../../img/login.png"
import mainImg from "../../img/main.png"
import payforImg from "../../img/payfor.png"
import setupImg from "../../img/setup.png"
import codeImg from "../../img/code.png"
import test from "../../img/test.mp4"
const { Title, Paragraph, Text } = Typography;
//<video width="420" height="200" src={test} controls autoplay>
       
//</video>
export default function Start() {
  const blockContent = "如果启动失败，可尝试运行repair.exe进行修复。"
  const [visible, setVisible] = useState(false);
  const dataSource = [
    {
      key: '1',
      peizhi1: '处理器：10代i7及以上',
      peizhi2: '处理器：i5及以上',
    },
    {
      key: '2',
      peizhi1: '内存：32GB及以上',
      peizhi2: '内存：16GB及以上',
    },
    {
      key: '3',
      peizhi1: '硬盘：20GB空闲',
      peizhi2: '硬盘：20GB空闲',
    },
    {
      key: '4',
      peizhi1: '显卡：RTX3060ti及以上',
      peizhi2: '显卡：GTX1060及以上',
    },
    {
      key: '5',
      peizhi1: '操作系统：Windows 10 64bit及以上',
      peizhi2: '操作系统：Windows 7 64bit及以上',
    },    
  ];

  const columns = [
    {
      title: '推荐配置',
      dataIndex: 'peizhi1',
      key: 'peizhi1',
    },
    {
      title: '最低配置',
      dataIndex: 'peizhi2',
      key: 'peizhi2',
    },
  ];
  return (
    <Typography>
      <Title level={2}>简介</Title>
      <Paragraph>
      朗维道路智能三维实景设计系统是一款基于三维实时渲染平台开发的智能参数化道路建模和景观布置软件，能够智能快速完成道路、桥梁、交叉口、隧道建模，并可参数化调整以及绿化景观和环境布置。
      本系统可以在30分钟内完成一张道路效果图；一个小时内完成道路动画，是路桥设计领域汇报、投标神器。
      </Paragraph>
      <Title level={2}>下载及安装</Title>
      <Title level={4}>配置要求</Title>
      <Paragraph>
      <Table dataSource={dataSource} columns={columns} pagination={{pageSize:50}}/>
      </Paragraph>
      <Title level={4}>下载</Title>
      <Paragraph>
        点击页面右上角<Text code>下载</Text>按钮，下载后解压即可运行，无需安装。
      </Paragraph>
      <Title level={2}>运行启动</Title>
      <Paragraph>
        双击<Text code>lwg.exe</Text>启动软件,如提示有最新版本，可选择是否更新。
        </Paragraph>
      <Paragraph>
        <Image width={800} src={setupImg} />
      </Paragraph>
      <Paragraph>
        首次运行若出现错误，可尝试安装<Text code>directx_Jun2010_redist.exe</Text>和<Text code>微软VC++运行库合集_2022.01.23.exe</Text>后，再尝试运行。
        </Paragraph>
      <Paragraph>
        <Image width={800} src={directxImg} />
      </Paragraph>
      <Title level={2}>账号注册与激活</Title>
      <Paragraph>
        首次需注册账号，然后使用激活码激活账号，软件提供账号登陆、注册、激活等界面服务，如下图所示。
        </Paragraph>
      <Paragraph>
        <Image width={800} src={loginImg} />
        </Paragraph>
        <Paragraph>
        激活码可以通过购买软件服务、申请试用获得，申请试用可在朗维道路公众号右下栏“联系我们”菜单下载试用申请函，下载填写单位信息后盖章扫描发回企业微信号，审批通过后获得激活码。
        </Paragraph>
      <Paragraph>
        <Image width={800} src={payforImg} />
      </Paragraph>
      <Paragraph>
      激活账号后，可以登录使用软件系统，成功登录界面如下：（登录后若首次运行需下载资源，往后不用再下载。资源文件较大，请耐心等待）
        </Paragraph>
      <Paragraph>
        <Image width={800} src={mainImg} />
      </Paragraph> 
      <Title level={2}>教程下载</Title>
      <Paragraph>
      <span style={{ textAlign: 'center'}}><a href="http://letwego.com.cn/Software/Letwego用户手册专业版.pdf" download>Letwego用户手册专业版.pdf</a></span> 
      </Paragraph>      
    </Typography>
  )
}
